import axios from '../javascript/custom-axios'
const V1 = '/v1'
const RESOURCE_NAME = '/stories'

export default {

  getStories(isPinned = false, page = 1, pageSize = 100, userId = "") {
    return axios.get(`${V1}${RESOURCE_NAME}/getuserbasedstories?isPinned=${isPinned}&page=${page}&pageSize=${pageSize}&userId=${userId}`)
  },

  deleteStory(id) {
    return axios.delete(`${V1}${RESOURCE_NAME}/${id}`)
  },

  createViewStory(body){
    return axios.post(`${V1}/views/create`, body)
  },

  pinStory(id){
    return axios.put(`${V1}${RESOURCE_NAME}/ProfilePinStoryById/${id}`)
  },

  unPinStory(id){
    return axios.put(`${V1}${RESOURCE_NAME}/ProfileUnPinStoryById/${id}`)
  }

}